export const backToJobsListText = "Back to jobs list";
